import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// Deferred ("delay") toast queue: lets a flow fire a toast immediately before a full page
// navigation and have it shown on the page that loads next. Persisted to sessionStorage so
// it survives the reload; drained on mount by GlobalLayout.
//
// toast message structure
// {
//   message: string,
//   type: 'success' | 'error' | 'warning' | 'info'   // mapped in ~/utils/toastV2Type
// }
//
// The drain renders through toast v2, so the page the flow navigates TO must mount an
// AppToasterV2Provider — otherwise the queued toast is fired into a channel with no
// toaster and is silently lost.
export const useSessionStore = create()(
  persist(
    (set, get) => ({
      toastMessages: [],
      setToastMessages: (messages) => set({ toastMessages: messages }),
      addToastMessage: (message, type) => set({ toastMessages: [...get().toastMessages, { message, type }] }),
    }),
    {
      name: 'session-store',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
